import { addYmd, formatYmdLong, kyivDate } from "@/lib/kyiv";
import { WEEKDAY_SHORT, weekdayIndexYmd, weekdayLabel } from "@/lib/timetable-core";

export function homeworkDueLabel(dueDate: string, today = kyivDate()): string {
  if (dueDate === today) return "сьогодні";
  if (addYmd(today, 1) === dueDate) {
    return `завтра, ${weekdayLabel(weekdayIndexYmd(dueDate))}`;
  }
  return formatYmdLong(dueDate);
}

export function homeworkDueShort(dueDate: string, today = kyivDate()): string {
  if (dueDate === today) return "сьогодні";
  if (addYmd(today, 1) === dueDate) return "завтра";
  return WEEKDAY_SHORT[weekdayIndexYmd(dueDate)] ?? dueDate;
}
